/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Button, Grid, TextField } from '@coursera/cds-core';

import { OpenSlackLink } from 'bundles/slack-account-link/components/SlackAccountLinkingButtons';
import { useSlackAccountLinkingForm } from 'bundles/slack-account-link/components/useSlackAccountLinkingForm';

import _t from 'i18n!nls/slack-account-link';

type componentState = 'VERIFY' | 'LINKED';

type Props = {
  mode: componentState;
  email: string;
  errorState?: boolean;
  slackLink?: string;
  onLink: (email: string) => void;
  unlinkButton?: React.ReactNode;
};

const styles = {
  //  added for consistency with rest of this page unfortunately.
  //  The label rule override a margin-bottom: 0.5rem introduced by another stylesheet (global i think, assuming bootstrap) on all label elements on this page
  textField: css`
    border-radius: 0;

    div,
    input {
      border-radius: 0;
    }

    label {
      margin-bottom: 0;
    }
  `,
  spacing: css`
    gap: var(--cds-spacing-200);
  `,
};

export const AccountLinkSlack = (props: Props) => {
  const { onLink, unlinkButton, email, errorState, mode, slackLink } = props;
  const isLinked = mode === 'LINKED';

  const { onSubmit, onChange, value } = useSlackAccountLinkingForm({
    onLink,
    email: email || '',
    errorState: !!errorState,
  });

  return (
    <div className="rc-AccountLinkSlack" data-testid="accountlink">
      <Grid container direction="column" css={styles.spacing}>
        <Grid
          container
          item
          direction="row"
          css={styles.spacing}
          alignItems="flex-end"
          onSubmit={onSubmit}
          component="form"
          noValidate
        >
          <Grid item sm={6} xs={12}>
            <TextField
              // I'm not really sure why this is necessary but it's in the existing component so i left it here.
              id={errorState ? 'SlackAccountEmailError' : 'SlackAccountEmail'}
              label={_t('Slack Account Email')}
              onChange={onChange}
              placeholder={_t('Email')}
              value={value}
              type="email"
              css={styles.textField}
              fullWidth={true}
              // for fullstory
              className="pii-hide"
              data-testid="slack-account-email"
            />
          </Grid>
          <Grid item>
            <Button variant="secondary" type="submit" data-testid="slack-account-email-verify">
              {_t('Link')}
            </Button>
          </Grid>
          {unlinkButton && <Grid item>{unlinkButton}</Grid>}
        </Grid>
        {isLinked && (
          <Grid item>
            <OpenSlackLink href={slackLink || 'slack://open'} />
          </Grid>
        )}
      </Grid>
    </div>
  );
};

export default AccountLinkSlack;
